export {
    ContentBlock,
    type ContentBlockProps,
    type HeaderTagTypes,
    type CTAProps,
    type EyebrowProps,
    type ButtonAndLinkProps,
    type ButtonAndSecondaryLinkProps,
    type OrientationTypes,
    type OneButtonProps,
    type OneLinkProps,
    type TwoLinksProps
} from "./content-block";
export { ContentBlock as default } from "./content-block";
